<template>
  <div class="filter-options">
    <list-searchable-options
      :options="props.filterOptions"
      :placeholder="$t('listFilter.search')"
      @select="emit('add-quick-filter', $event)"
    />
    <m-divider none />
    <m-content :padding-y="4">
      <m-card-item
        class="_add-advanced-filter"
        :icon="advancedFilterExists ? 'funnel' : 'plus'"
        @click="emit('add-advanced-filter')"
      >
        <template v-if="advancedFilterExists">
          <div class="_advanced-filter">
            <span class="_title">{{ $t('filterChips.advancedFilter') }}</span>
            <span class="_rules-count">{{ advancedFilterLength }} {{ $t('filterChips.rule', { count: advancedFilterLength }) }}</span>
          </div>
        </template>
        <template v-else>
          {{ $t('filterChips.addAdvancedFilter') }}
        </template>
      </m-card-item>
    </m-content>
  </div>
</template>

<script setup>
import ListSearchableOptions from '@/components/list/ListSearchableOptions.vue';
import { computed } from 'vue';

const props = defineProps({
  filterOptions: {
    type: Array,
    default: () => [],
  },
  advancedFilterLength: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['add-quick-filter', 'add-advanced-filter']);

const advancedFilterExists = computed(() => props.advancedFilterLength > 0);

</script>

<style scoped lang="scss" type="text/scss">
.filter-options {
  ._advanced-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    ._title {
      margin-right: 2rem;
    }

    ._rules-count {
      color: map_get($colors, 'grey', 'base');
      margin-left: auto;
    }
  }
}
</style>
